import { Fragment, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { Card } from "primereact/card";

import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";

import { useNavigationService } from "../../../hooks/useNavigationService";
import { translationKeys } from "../../../models/app-translation-keys";
import { Icon } from "../../Shared/Icon/Icon";

import "./LandingPage.scss";

const RawLandingPage: FunctionComponent = () => {
  const { t } = useTranslation();

  const navigationService = useNavigationService();

  const landingPageTranslationsKeys = translationKeys.pages.landingPage;

  const availableFeatures = navigationService.availableFeatures;

  return (
    <div className="landing-container">
      <div className="landing-page-header">
        <h1 className="landing-page-header-title">
          <span>{t(landingPageTranslationsKeys.title)}</span>{" "}
          <span className="landing-page-header-title-app">{t(translationKeys.app.title)}</span>
        </h1>

        <h3 className="landing-page-header-subtitle">{t(landingPageTranslationsKeys.subTitle)}</h3>
      </div>

      {availableFeatures.length > 0 ? (
        <div className={`features features-${availableFeatures.length}`}>
          {availableFeatures.map(feature => (
            <Fragment key={feature.route.path}>{feature.card}</Fragment>
          ))}
        </div>
      ) : (
        <div className="features feature-list-error-card">
          <Card title={<Icon icon={faTriangleExclamation} iconSize="3xl" color="warning" />}>
            <h4>{t(landingPageTranslationsKeys.noAvailableFeatures.title)}</h4>

            <p>{t(landingPageTranslationsKeys.noAvailableFeatures.description)}</p>
          </Card>
        </div>
      )}
    </div>
  );
};

export const LandingPage = observer(RawLandingPage);
